import React from 'react';
import { footerGlobal } from '../../partnerStyles';
import FooterHead from './FooterHead';

import FooterGeneralContent from './FooterGeneralContent';
import FooterOYOcategories from './FooterOYOcategories';
import FooterNearbyPlaces from './FooterNearbyPlaces';
import FooterBottomLinks from './FooterBottomLinks';

const Footer = props => {
  let footerHeight = 237;

  let gc = props.getContent;
  let guc = props.getUniversalContent;
  let gs = props.getStyle;
  let gi = props.getImage;

  return (
    <div
      ref={props.setFooterRef}
      style={{
        ...footerGlobal,
        height: footerHeight + 'px'
      }}
    >
      <FooterHead
        getImage={props.getImage}
        getStyle={props.getStyle}
        getContent={props.getContent}
        getUniversalContent={props.getUniversalContent}
      />

      {/*<FooterGeneralContent />*/}

      {/*<FooterOYOcategories />*/}

      {/*<FooterNearbyPlaces />*/}

      <FooterBottomLinks />
    </div>
  );
};

export default Footer;
